export default "__VITE_ASSET__DspUOWQS__"